import { gql, useApolloClient } from "@apollo/client";
import { useSnackbarApi } from "@comet/admin";
import { Cancel } from "@mui/icons-material";
import { Button, Dialog } from "@mui/material";
import Snackbar from "@src/components/snackbar/Snackbar";
// eslint-disable-next-line @comet/no-private-sibling-import
import { FormButtonsWrapper } from "@src/domain/devices/edit/Form.sc";
import { type GQLReconfigureCameraAdminMutation, type GQLReconfigureCameraAdminMutationVariables } from "@src/graphql.generated";
import Delete from "@src/icons/Delete";
import { type ReactElement } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { ContentWrapper } from "../..";

export interface CommonInitializeDialogProps {
    open: boolean;
    handleClose: () => void;
    title: string | ReactElement;
    dialogBody: ReactElement;
    cameraId: string;
}

const reconfigureCameraAdminMutation = gql`
    mutation ReconfigureCameraAdmin($id: ID!) {
        reconfigureCameraAdmin(id: $id)
    }
`;

const InitializeDeviceDialog = ({ title, open, handleClose, dialogBody, cameraId }: CommonInitializeDialogProps): ReactElement => {
    const client = useApolloClient();
    const snackbarApi = useSnackbarApi();
    const intl = useIntl();

    const submit = async () => {
        await client.mutate<GQLReconfigureCameraAdminMutation, GQLReconfigureCameraAdminMutationVariables>({
            mutation: reconfigureCameraAdminMutation,
            variables: { id: cameraId },
            refetchQueries: ["CameraAdmin", "LogsAdmin"],
        });
        handleClose();

        snackbarApi.showSnackbar(
            <Snackbar
                variant="success"
                message={intl.formatMessage({
                    id: "reviermanager.camera.initialize",
                    defaultMessage: "Kamera wurde neu initialisiert",
                })}
                key="reviermanager.camera.initialize"
                handleClose={snackbarApi.hideSnackbar}
            />,
        );
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <ContentWrapper title={title}>
                {dialogBody}
                <FormButtonsWrapper>
                    <Button startIcon={<Cancel />} variant="text" onClick={handleClose}>
                        <FormattedMessage id="reviermanager.button.cancel" defaultMessage="Abbrechen" />
                    </Button>
                    <Button color="primary" variant="contained" startIcon={<Delete />} onClick={submit}>
                        <FormattedMessage id="reviermanager.button.initialize" defaultMessage="Ja, neu initialisieren" />
                    </Button>
                </FormButtonsWrapper>
            </ContentWrapper>
        </Dialog>
    );
};

export default InitializeDeviceDialog;
